export default __webpack_public_path__ + "images/referrals-onboarding-step-4.8d3f8707639aed0e6e489d02216dcc9a.png";